<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Ticket'
};
</script>

<style lang="less" scoped>
</style>
